import { styled } from '@material-ui/core'

import { fonts } from '~/theme/typography'

import Text from './Text'

const HebrewText = styled(Text)({
  fontFamily: fonts.rubik
})

export default HebrewText
